import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {
  ConfirmBoxConfigModule,
  DialogConfigModule,
  NgxAwesomePopupModule,
  ToastNotificationConfigModule
} from '@costlydeveloper/ngx-awesome-popup';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ApplyNowCardComponent } from './common/apply-now-card/apply-now-card.component';
import { FooterComponent } from './common/footer/footer.component';
import { HeaderComponent } from './common/header/header.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { ApplyNowComponent } from './pages/apply-now/apply-now.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { FaqComponent } from './pages/faq/faq.component';
import { HomeComponent } from './pages/home/home.component';
import { PartnersComponent } from './pages/partners/partners.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { ThankYouComponent } from './pages/thank-you/thank-you.component';

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    ApplyNowCardComponent,
    HomeComponent,
    HeaderComponent,
    ContactUsComponent,
    AboutUsComponent,
    ApplyNowComponent,
    PartnersComponent,
    FaqComponent,
    PrivacyPolicyComponent,
    ThankYouComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    NgxAwesomePopupModule.forRoot(), // Essential, mandatory main module.
    DialogConfigModule.forRoot(), // Needed for instantiating dynamic components.
    ConfirmBoxConfigModule.forRoot(), // Needed for instantiating confirm boxes.
    ToastNotificationConfigModule.forRoot(), // Needed for instantiating toast notifications.
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
